import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GiftCardactivation from './GiftCardactivationRevamp';
import GiftCardEntry from './GiftCardEntryRevamp';
import Modal from '@components/common/Modal';
import cn from 'classnames';
import {
  giftCardProcess, giftCardValidate, giftCardBalances, giftCardSwipe, giftCardActivate
} from '@reducers/payment';
import { setSeat, setSyncData, setPaymentCheck, setIsFromCheckList, replaceCart } from '@reducers/orders';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { syncCheckForPayment, syncForPayment } from '@reducers/storeChecks';
import EventEmitter from '@utility/eventSubscribers';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { APP_CONFIG } from '@constants';
import { getObjectValue, urlSearchParams } from '../../utility/utills';
// import swipeGiftCard from "@assets/JSON_Files/Swipe_Gift_Card"
import swipeGiftCard from '@assets/images/GIFs/Swipe_Gift_Card.gif';
import { TouchableButton } from '@components/common/Touchable'
import { safeJsonParse } from '@utility/helperFunction';
import ModalHeader from '../../components/common/ModalHeader/index';
import Loader from '@components/common/Loader/newLoaderModal';
import style from './giftCardEntry.module.css';

const GiftCard = (props) => {

  // Props Destructuring

  const {
    auth,
    deviceInfo,
    userInfo,
    seat,
    giftCardBalances,
    setErrorPopUp,
    giftCardSwipe,
    setNotification,
    menuItemsHashTable,
    // giftCardProcess,
    setSeat,
    setSyncData,
    setPaymentCheck,
    serverAppTheme,
    syncForPayment,
    giftCardActivate,
    setIsFromCheckList,
    isFromCheckList,
    orderingPortraitOrientation
  } = props;

  // State Management

  const isBalanceRouteCheck = urlSearchParams('type') == 'balance';
  const balanceEnabledCheck = window.sessionStorage.getItem("giftCard_type");
  const giftCardMethodsToCheck = balanceEnabledCheck
    ? props.auth?.loyaltyInfo?.giftCardMethods
    : props.auth?.loyaltyInfo?.giftCardSaleMethods;
  const shouldDirectSwipe = isBalanceRouteCheck &&
    giftCardMethodsToCheck?.length === 1 &&
    giftCardMethodsToCheck?.includes("swipe");

  const [gameCardFlowType, setGameCardFlowType] = useState((urlSearchParams('type') == 'balance' || urlSearchParams('type') == 'payment') ? (shouldDirectSwipe ? 1 : 2) : 1);
  const [gameCardData, setGameCardData] = useState(null)
  const [isSwipe, setIsSwipe] = useState(shouldDirectSwipe);
  const [cardError, setCardError] = useState(false)
  const cardStatus = seat?.cards?.filter(e => e.status === 5)
  const [swiped, setSwiped] = useState(cardStatus || []);
  const [tab, setTab] = useState(urlSearchParams('type') == 'more' ? true : false);
  const [sendAndActivatepopUp, setSendAndActivatepopUp] = useState(false);
  const isBalanceRoute = urlSearchParams('type') == 'balance' ? true : false;
  const [checkbalance, setCheckbalance] = useState(isBalanceRoute)
  const [balancePopUp, setBalancePopUp] = useState({ state: false, data: null, cardNumber: null });
  let disPlayBackArrow = isBalanceRoute ? true : false;
  const isFromPaymentScreen = urlSearchParams('type') == 'payment' ? true : false;
  const [isLandScape, setIsLandScape] = useState(true)
  const [inputs, setInputs] = useState('');
  const [swipedDown, setSwipedDown] = useState(false);
  const [typed, setTyped] = useState({});
  const [payLoading, setPayLoading] = useState(false);

  const [selectedMenuItemId, setSelectedMenuItemId] = useState(null);
  const [displayImage, setDisplayImage] = useState(swipeGiftCard);
  const [orderData, setOrderData] = useState(null);
  const balanceEnabled = window.sessionStorage.getItem("giftCard_type");

  const menuItemName = orderData?.name ?? "";

  // React Hooks

  useEffect(() => {
    if (shouldDirectSwipe && isBalanceRoute && checkbalance && isSwipe) {
      const timer = setTimeout(() => {
        activateIngenicoDevice(null);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  const OnProcess = (data) => {
    setGameCardData(data);
    const items = seat?.orders?.[0]?.items || [];
    const itemIdForImg = items?.find(e => e.id === data?.checkOrderItemId);

    const menuItemId = safeJsonParse(itemIdForImg?.orderJson)?.menuItemId;
    setSelectedMenuItemId(menuItemId);

    const intermediateImageUrl = menuItemsHashTable[menuItemId]?.largeImageUrl;
    setDisplayImage(intermediateImageUrl || swipeGiftCard);

    if (props.auth?.loyaltyInfo?.giftCardSaleMethods?.length === 1 && props.auth?.loyaltyInfo?.giftCardSaleMethods.includes("swipe")) {
      openCardPopUp(data)
    } else if (true && auth?.loyaltyInfo?.giftCardSaleMethods.length != 0 && auth?.loyaltyInfo?.giftCardSaleMethods.includes('type')) {
      setGameCardFlowType(2)
    } else {
      openCardPopUp(data)
    }
  }

  const handleBackBtn = () => {
    setGameCardFlowType(1)
    setGameCardData(null);
    setBalancePopUp({
      state: false,
      data: null,
      cardNumber: null,
    });
    setCheckbalance(isBalanceRoute)
  }

  const handleGiftCardProcess = (data) => {
    if (!isFromPaymentScreen) {
      const dataToSend = {
        deviceId: deviceInfo.deviceId,
        storeId: userInfo.storeId,
        employeeId: userInfo.id,
        checkHeaderId: checkbalance ? null : seat.id,
        checkCardId: checkbalance ? null : gameCardData?.id,
        entryMethod: typeof data === 'object' ? data.method || 'type' : 'type',
        cardNumber: typeof data === 'object' ? data.cardNumber : data,
        amount: gameCardData?.amount || 0,
        displayCardNumber: typeof data === 'object' ? data.cardNumber : data,

      }

      if (typeof data === 'object' && data.securityCode && checkbalance) {
        dataToSend.securityCode = data.securityCode;
      }
      if (checkbalance) {
        delete dataToSend.amount;
        giftCardBalances(dataToSend).then((res) => {
          setBalancePopUp({
            state: true,
            data: res,
            // cardNumber: dataToSend.cardNumber,
             cardNumber: res.cardNumber,
          });
          if (balanceEnabled) window.sessionStorage.removeItem('giftCard_type');
        }).catch((err) => {
          if (shouldDirectSwipe && isBalanceRoute) {
            setIsSwipe(false);
            handleStopMagneticRead();
            props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
              replace: true,
            });
          }
          setErrorPopUp({
            res: err.message
          })
          if (!shouldDirectSwipe) {
            setCheckbalance(disPlayBackArrow ? true : false);
            setGameCardFlowType(disPlayBackArrow ? 2 : 1);
          }
        })
      } else {
        // giftCardValidate(dataToSend).then((res) => {
        giftCardActivate(dataToSend).then((res) => {
          let value = {
            checkCardId: gameCardData?.id,
            entryMethod: 'type',
            cardNumber: res.cardNumber,
            cardId: res.cardId,
            displayCardNumber: res.displayCardNumber,
            cardTrack: res.cardTrack,
            // amount: safeJsonParse(gameCardData?.orderJson)?.price || 0
            amount: gameCardData?.amount || 0
          }
          const isPresent = swiped.some(item => item.checkCardId === gameCardData?.id);
          if (!isPresent) {
            setSwiped(prevArray => [...prevArray, value])

          } else {
            let index = swiped.findIndex(obj => obj.checkOrderItemId === gameCardData?.id);
            if (index !== -1) {
              swiped[index] = value;
            }
          }
          const ItemsArray = res.orders[0]?.items || [];
                  if (ItemsArray?.length > 0) {
                    const CartItems = [];
                    ItemsArray.forEach(item => {
                      if (item.pending && item.itemType !== 'D') {
                        const cartData = {
                          ...JSON.parse(JSON.parse(item?.orderJson)?.modifierJson),
                          isProcessing: false,
                          modifierJson: JSON.parse(item?.orderJson)?.modifierJson,
                          id: item.id,
                          checkItemId: item.checkItemId,
                          pending: item.pending,
                        };
                        CartItems.push(cartData);
                      }
                    });
                    props.replaceCart(CartItems);

                  }
          setGameCardFlowType(1);
          setSeat(res);
        }).catch((err) => {
          setErrorPopUp({
            res: err.message,
          })
        })
      }
    }
    else {
      const cardId = urlSearchParams('cardId');
      const payload = {
        deviceId: deviceInfo.deviceId,
        storeId: userInfo.storeId,
        employeeId: userInfo.id,
        checkHeaderId: seat.id,
        entryMethod: 'type',
        cardId: cardId,
        cardNumber: data,
      }
      giftCardSwipe(payload).then((res) => {
        setNotification({
          type: 'success',
          message: "Gift card activation success"
        })
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${seat.id
          }?ticketSplitTypeId=1&splitValue=1&screenType=27&type=${urlSearchParams(
            'type'
          )}`,
          { replace: true }
        );
      }).catch(error => {
        setErrorPopUp({
          res: error.message
        })
      })
    }
  }

  const handleSwipeGameCard = (data) => {
    if(!data?.data) data.data = gameCardData;
    let dataToSend;
    if (!isFromPaymentScreen) {
      if (checkbalance) {
        dataToSend = {
          deviceId: deviceInfo.deviceId,
          storeId: userInfo.storeId,
          employeeId: userInfo.id,
          checkHeaderId: checkbalance ? null : seat.id,
          checkOrderItemId: checkbalance ? null : data.data?.id,
          entryMethod: data.method,
          cardNumber: data?.cardNumber,
          displayCardNumber: data?.cardNumber,
        }
      } else {
        dataToSend = {
          deviceId: deviceInfo.deviceId,
          storeId: userInfo.storeId,
          employeeId: userInfo.id,
          checkHeaderId: checkbalance ? null : seat.id,
          checkCardId: checkbalance ? null : data.data?.id,
          entryMethod: data.method,
          cardNumber: data?.cardNumber,
          amount: data.data?.amount || 0,
          displayCardNumber: data?.cardNumber,
        }
      }
      if (checkbalance) {
        giftCardBalances(dataToSend).then((res) => {
          setBalancePopUp({
            state: true,
            data: res,
            // cardNumber: dataToSend.cardNumber,
             cardNumber: res.cardNumber,
          });
        }).catch((err) => {
          if (shouldDirectSwipe && isBalanceRoute) {
            setIsSwipe(false);
            handleStopMagneticRead();
            props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
              replace: true,
            });
          }
          setErrorPopUp({
            res: err.message
          })
          if (!shouldDirectSwipe) {
            setCheckbalance(disPlayBackArrow ? true : false);
            setGameCardFlowType(disPlayBackArrow ? 2 : 1);
          }
        })
      } else {
        // giftCardValidate(dataToSend).then((res) => {
          giftCardActivate(dataToSend).then((res) => {
          let value = {
            checkCardId: data.data?.id,
            entryMethod: data.method,
            cardNumber: res.cardNumber,
            cardId: res.cardId,
            displayCardNumber: res.displayCardNumber,
            cardTrack: res.cardTrack,
            // amount: safeJsonParse(data.data?.orderJson)?.price ||
            amount: data.data?.amount || 0,
          }
          const isPresent = swiped.some(item => item.checkCardId === data.data?.id);
          if (!isPresent) {
            setSwiped(prevArray => [...prevArray, value])
          } else {
            let index = swiped.findIndex(obj => obj.checkOrderItemId === data.data?.id);
            if (index !== -1) {
              swiped[index] = value;
            }
          }
          setGameCardFlowType(1);
          setSeat(res);
        }).catch((err) => {
          setErrorPopUp({
            res: err.message,
          })
        })
      }
    }
    else {
      const cardId = urlSearchParams('cardId');

      const payload = {
        deviceId: deviceInfo.deviceId,
        storeId: userInfo.storeId,
        employeeId: userInfo.id,
        checkHeaderId: seat.id,
        entryMethod: 'type',
        cardId: cardId,
        cardNumber: data?.cardNumber,
      }
      giftCardSwipe(payload).then((res) => {
        window.sessionStorage.setItem('cards', JSON.stringify(res.checkHeader.cards));
        setNotification({
          type: 'success',
          message: "Gift card activation success"
        })
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${seat.id
          }?ticketSplitTypeId=1&splitValue=1&screenType=27&type=${urlSearchParams(
            'type'
          )}`,
          { replace: true }
        );
      }).catch(error => {
        setErrorPopUp({
          res: error.message
        })
      })
    }
  }

  const handleStopMagneticRead = () => {
    EventEmitter.stopMagneticCardRead((res) => {
    });
    EventEmitter.sendMessage({ type: 'stopMagCard' }, () => {
      console.log('success');
    },
      () => {
        console.log('failure');
      });
    setIsSwipe(false);
  };

  const activateIngenicoDevice = (data) => {
    try {
      EventEmitter.scanIngenicoDevice((res) => {
        handleSwipeGameCard({ cardNumber: res, method: 'swipe', data: data });
        handleStopMagneticRead();
      },
        () => {
          handleStopMagneticRead();
        });
      EventEmitter.sendMessage({ type: 'scanMagCard' }, () => {
        console.log('success');
      },
        () => {
          console.log('failure');
        });
    } catch (e) {
      console.log('catch', e);
    }
  };

  const openCardPopUp = (data) => {
    setIsSwipe(true);
    activateIngenicoDevice(data);
  };


  const getActivateGiftCards = () => {
    const data = [...(seat?.cards || [])];
    const items = seat?.orders?.[0]?.items || [];

    return data
      .filter((card) => {
        const matchedItem = items.find((it) => it.id === card.checkOrderItemId) || null;
        const orderJson = safeJsonParse(matchedItem?.orderJson);
        const menuItem = menuItemsHashTable?.[orderJson?.menuItemId];
        return menuItem?.cardType === 2 && ((card?.status === 0 && !card?.void) || card?.status === 5);
      })
      .sort((a, b) => {
        const isBonusA = a.subType === "bonus";
        const isBonusB = b.subType === "bonus";

        // 1 Regular first, bonus second
        if (!isBonusA && isBonusB) return -1;
        if (isBonusA && !isBonusB) return 1;

        // 2 Within each group → sort by amount DESC
        return b.amount - a.amount;
      });
  };

  const getSubTotalAmount = (table) => {
    return auth.country === 1 ? +(table.itemAmount) : +(table.subTotalAmount);
  };

  const getTotalAmount = (table) => {
    const discount = getObjectValue(() => table.discountAmount, 0);
    const serviceCharge = getObjectValue(() => table.serviceChargeAmount, 0);
    return auth.country === 1 ? +(table.itemAmount + table.taxAmount + serviceCharge - discount) : +(table.itemAmount - discount);
  };

 const sendAndPayApi = () => {
  const dataToSend = {
    deviceId: deviceInfo.deviceId,
    storeId: userInfo.storeId,
    employeeId: userInfo.id,
    checkHeaderId: seat.id,
    cards: swiped,
  };

  if (swiped.length === getActivateGiftCards().length) {
    setPayLoading(true);
    // Do not remove this commented code:
    // giftCardProcess(dataToSend)
    //   .then((res) => {
    //     setSeat(res);
    //     setSwiped([]);
    //     setTab(false);

    //     const syncDataToSend = {
    //       deviceId: deviceInfo.deviceId,
    //       employeeId: Number(userInfo.id),
    //       storeId: deviceInfo.storeId,
    //       checkHeaderId: seat.id,
    //       totalAmount: seat.totalAmount,
    //       unpaidAmount: Number(seat.unpaidAmount),
    //       paidAmount: seat.paidAmount,
    //     };
    //     return syncForPayment(syncDataToSend);
    //   })
    const syncDataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: Number(userInfo.id),
      storeId: deviceInfo.storeId,
      checkHeaderId: seat.id,
      totalAmount: seat.totalAmount,
      unpaidAmount: Number(seat.unpaidAmount),
      paidAmount: seat.paidAmount,
    };
      syncForPayment(syncDataToSend)
      .then((res) => {
        const data = res?.check;
        data.control = res?.control;
        data.checkHeaderId = res?.checkHeaderId;

        const updatedData = {
          ...data,
          subTotalAmount: getSubTotalAmount(data),
          totalAmount: getTotalAmount(data),
        };

        setSeat(updatedData);
        setSyncData(updatedData);

        return setPaymentCheck(updatedData).then(() => {
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${data.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
            { replace: true }
          );
        });
      })
      .catch((err) => {
        setErrorPopUp({
          res: err.message,
        });
      })
      .finally(() => {
        setPayLoading(false);
      });
  } else {
    setErrorPopUp({
      res: "All cards must be swiped before proceeding to payment",
      noErrorTxt: true,
    });
  }
};

  // const sendAndPayApi = () => {
  //   const dataToSend = {
  //     deviceId: deviceInfo.deviceId,
  //     storeId: userInfo.storeId,
  //     employeeId: userInfo.id,
  //     checkHeaderId: seat.id,
  //     cards: swiped,
  //   }
  //   if (swiped.length == getActivateGiftCards().length) {
  //     giftCardProcess(dataToSend).then((res) => {
  //       setSeat(res)
  //       setSwiped([])
  //       setTab(false)
  //       const dataToSend = {
  //         deviceId: deviceInfo.deviceId,
  //         employeeId: Number(userInfo.id),
  //         storeId: deviceInfo.storeId,
  //         checkHeaderId: seat.id,
  //         totalAmount: seat.totalAmount,
  //         unpaidAmount: Number(seat.unpaidAmount),
  //         paidAmount: seat.paidAmount,
  //       };
  //       syncForPayment(dataToSend)
  //         .then(res => {
  //           const data = res?.check;
  //           data.control = res?.control;
  //           data.checkHeaderId = res?.checkHeaderId;
  //           setSeat({
  //             ...data,
  //             subTotalAmount: getSubTotalAmount(data),
  //             totalAmount: getTotalAmount(data),
  //           });
  //           setSyncData({
  //             ...data,
  //             subTotalAmount: getSubTotalAmount(data),
  //             totalAmount: getTotalAmount(data),
  //           });
  //           setPaymentCheck({
  //             ...data,
  //             subTotalAmount: getSubTotalAmount(data),
  //             totalAmount: getTotalAmount(data),
  //           }).then(() => {
  //             window.sessionStorage.setItem('giftCardpayment', true);
  //             props.navigate(
  //               `${APP_CONFIG.BASE_URL}/receipt/${data.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
  //               { replace: true }
  //             );
  //           });
  //         })
  //         .catch(err => {
  //           setPayLoading(false);
  //           setErrorPopUp({
  //             res: err.message,
  //           });
  //         });

  //     }).catch((err) => {
  //       setErrorPopUp({
  //         res: err.message
  //       })
  //     })
  //   } else {
  //     setErrorPopUp({
  //       res: 'All cards must be swiped before proceeding to payment',
  //       noErrorTxt: true,
  //     })
  //   }
  // }


  const checkBalance = () => {
    setCheckbalance(true)
    setGameCardFlowType(2)
  }

  const handleClosePopup = () => {
    setBalancePopUp({
      state: false,
      data: null,
      cardNumber: null,
    });
    setSwipedDown(false);
    setInputs('');
    setTyped({});
    setCheckbalance(isBalanceRoute);
    if(urlSearchParams("type") === "balance") {
      props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
        replace: true,
      });
    } else {
      setGameCardFlowType(1);
    }
  }

  const handleCancelFunc = () => {
    if (balanceEnabled) {
      if(urlSearchParams("type") === "balance") {
      props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
        replace: true,
      });
    }
      window.sessionStorage.removeItem('giftCard_type');
      setCheckbalance(false);
    }
    setGameCardFlowType(1);
    handleStopMagneticRead();
  };



  const handleGiftcardFlowType = () => {
    switch (gameCardFlowType) {
      case 1:
        return (
          <GiftCardactivation
            {...props}
            OnProcess={OnProcess}
            swiped={swiped}
            tab={tab}
            setTab={setTab}
            sendAndPay={sendAndPayApi}
            loading={props.loading}
            checkBalance={checkBalance}
            getActivateGiftCards={getActivateGiftCards}
            serverAppTheme={serverAppTheme}
            openCardPopUp={openCardPopUp}
            orderData={orderData}
            setOrderData={setOrderData}
            balanceEnabled={balanceEnabled}
            seat={seat}
            setIsFromCheckList={setIsFromCheckList}
            isFromCheckList={isFromCheckList}
            orderingPortraitOrientation = {orderingPortraitOrientation}
          />
        );
      case 2:
        return (
          <GiftCardEntry
            {...props}
            handleBackBtn={handleBackBtn}
            handleGiftCardProcess={handleGiftCardProcess}
            openCardPopUp={openCardPopUp}
            isSwipe={isSwipe}
            handleStopMagneticRead={handleStopMagneticRead}
            cardError={cardError}
            setCardError={setCardError}
            loading={props.loading}
            menuItemsHashTable={menuItemsHashTable}
            balancePopUp={balancePopUp}
            handleClosePopup={handleClosePopup}
            serverAppTheme={serverAppTheme}
            isLandScape={isLandScape}
            setInputs={setInputs}
            inputs={inputs}
            setSwipedDown={setSwipedDown}
            swipedDown={swipedDown}
            setTyped={setTyped}
            typed={typed}
            setErrorPopUp={setErrorPopUp}
            checkbalance={checkbalance}
            selectedMenuItemId={selectedMenuItemId}
            setDisplayImage={setDisplayImage}
            swipeGiftCard={swipeGiftCard}
            orderData={orderData}
            setOrderData={setOrderData}
            menuItemName={menuItemName}
            balanceEnabled={balanceEnabled}
            setGameCardFlowType={setGameCardFlowType}
            isBalanceRoute={isBalanceRoute}
            orderingPortraitOrientation={orderingPortraitOrientation}
          />
        );
      default:
        return <div />;
    }
  };

  // HTML CSS Code
  return (
    <>
    {payLoading && <Loader />}
      <div
        style={{
          fontFamily: 'poppins',
          background: serverAppTheme?.background_color,
        }}
        className={cn('col-12 px-0', !isSwipe && 'h-100')}
      >
        {!isSwipe && handleGiftcardFlowType()}
      </div>
      {sendAndActivatepopUp && (
        <Modal
          isOpen={sendAndActivatepopUp}
          isModalCenter
          loading={props.loading}
          style={{
            backgroundColor: serverAppTheme.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            width: isLandScape ? '79%' : '100%',
            margin: 'auto',
            minHeight: isLandScape ? '45%' : '25%',
            height: 'auto',
            padding: '1.5rem',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
          }}
          customClass="h-100 w-100"
          customClass2="h-100 w-100 p-3"
          noBackground
        >
          <div
            className="justify-content-center align-items-center text-center h-100 position-relative"
            style={{ flex: 1, color: serverAppTheme?.primary_text }}
          >
            <div className="col-12 fs_18 fw-700 text-center mb-3">
              <div>Are you sure?</div>
            </div>
            <div className="col-12 px-0 fs_16 fw-400 text-center h-auto">
              {CUSTOM_MESSAGES().SWIPE_MESSAGE}
            </div>
            <div
              style={{ bottom: '0', left: '0' }}
              className="col-12 px-0 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute"
            >
              <div className="col-6 pl-0 pr-1">
                <TouchableButton
                  type="submit"
                  style={{
                    backgroundColor: serverAppTheme.OFF_Premise_Btn,
                    border: serverAppTheme.cancleBtn_Border,
                    color: serverAppTheme.cancleBtn_font,
                  }}
                  className={cn('col-12 fs-24 fw-600 btn44 rounded')}
                  onClick={() => {
                    setSendAndActivatepopUp(false);
                  }}
                >
                  {LABEL().NO}
                </TouchableButton>
              </div>
              <div className="col-6 pl-1 pr-0">
                <TouchableButton
                  type="submit"
                  style={{
                    backgroundColor: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  className={cn(
                    'col-12 btn-ripple fs-24 fw-600 btn44 border-0 rounded'
                  )}
                  onClick={() => {
                    setSendAndActivatepopUp(false);
                    sendAndPayApi();
                  }}
                >
                  {LABEL().YES}
                </TouchableButton>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {isSwipe && (
        <div className="col-12 px-0 h-100" style={{ backgroundColor: serverAppTheme?.background_color }}>
          <div
            className="col-12 px-0 position-relative h-100"
            style={{ color: props.serverAppTheme?.primary_text }}
          >
            <ModalHeader
              // isTab={seat?.tab}
              // stationName={seat?.stationName}
              // seatNumber={seat?.number}
                tileHeader="Gift Card"
                {...(urlSearchParams('type') == 'balance'  ? {} : { isTab: seat?.tab })}
                {...(urlSearchParams('type') == 'balance'  ? {} : { stationName: seat?.stationName })}
                {...(urlSearchParams('type') == 'balance'  ? {} : {seatNumber: seat?.number })}
            />
            <div className="col-12 px-0 h-100">
              <div className={cn("col-12 fs_18 fw-700 justify-content-center align-items-center text-center", orderingPortraitOrientation ? 'pt-3' : '')}>
                {CUSTOM_MESSAGES().SWIPE_CARD_AFTER_BEEP}
              </div>
              {urlSearchParams("type") !== "balance" && orderData &&(
                <div
                  className={cn("m-auto d-flex justify-content-between px-2 pt-10 fs-20", orderingPortraitOrientation ? 'col-6 fs_18' : 'col-5')}
                  style={{
                    backgroundColor: serverAppTheme?.popUp_bg,
                    borderRadius: "8px",
                    color: serverAppTheme?.primary_text,
                    fontWeight: 600,
                  }}
                >
                  <span>{menuItemName}</span>
                  {orderData.amount !== 0 && (
                    <span>{LABEL().CURRENCY_SYMBOL}{orderData.amount.toFixed(2)}</span>
                  )}
                </div>
              )}
              <div
                className={cn(
                  'mx-0 py-2 px-0 row align-items-end col-12 justify-content-center text-center', displayImage !== swipeGiftCard ? style.imageHt : `${style.resImg} h-80`
                )}
              >

                {/* <Lottie
                  style={{ height: '100%', width: '100%' }}
                  animationData={swipeGiftCard}
                  loop={true}
                  autoplay={true}
                  speed={1}
                /> */}
                <img
                  src={displayImage}
                  alt="success"
                  className={cn(
                    isBalanceRoute && "h-100",
                    displayImage !== swipeGiftCard
                      ? style.imgHeight
                      : urlSearchParams("type") !== "balance" && orderData
                        ? style.imgHeight3
                        : style.imgHeight2,
                  )}
                />
              </div>
              <div
                className="row px-0 mx-0 justify-content-center position-absolute"
                style={{ bottom: orderingPortraitOrientation ? '3.5rem' : '3rem', width: '96%', left: '2%' }}
              >
                <div className={cn("px-0 d-flex justify-content-center align-items-center", orderingPortraitOrientation ? 'col-6' : 'col-4')}>
                  <TouchableButton
                    className={cn("col-12 px-0 fs-28 fw-600 btn-ripple border-0 rounded d-flex justify-content-center align-items-center", orderingPortraitOrientation ? 'btn68' : 'btn44')}
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCancelFunc();
                    }}
                    style={{
                      backgroundColor: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      borderRadius: '8px',
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().CANCEL}
                  </TouchableButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// Redux Part

const mapStateToProps = ({ oauth, orders, payment, storeChecks, theme }) => ({
  auth: oauth.authInfo,
  deviceInfo: oauth.deviceInformation,
  paymentCheck: orders.paymentCheck,
  seat: orders.seats,
  userInfo: oauth.loggedInUserData,
  loading: payment.loading || storeChecks.loading || orders.loading,
  menuItemsHashTable: orders.menuItemsHashTable,
  serverAppTheme: theme.serverAppTheme,
  cart: orders.cart,
  isFromCheckList: orders.isFromCheckList,
  checkListHashTable: storeChecks.checkListHashTable,
  orderingPortraitOrientation: orders.orderingPortraitOrientation,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      giftCardProcess,
      setSeat,
      setSyncData,
      setPaymentCheck,
      setNotification,
      giftCardValidate,
      giftCardBalances,
      syncCheckForPayment,
      giftCardSwipe,
      setErrorPopUp,
      syncForPayment,
      giftCardActivate,
      setIsFromCheckList,
      replaceCart
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GiftCard);